import Cookie from 'js-cookie';
import { EnrichData, NULL, RETRIES, RETRY_INTERVAL, SESSION_ID, UNDEFINED } from '../types';
import ls from './localStorage';
export { ls };
export var getCookie = function getCookie(name) {
  return Cookie.get(name);
};
export var noWindow = function noWindow() {
  return typeof window === 'undefined';
};
export var Logger = {
  info: function info(title) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var infoMsg = ['[r2wc]', title].concat(args).join(' ');
    if (!noWindow()) {
      console.log(infoMsg);
    }
  },
  error: function error(title) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    var errorMsg = ['[r2wc]', title].concat(args).join(' ');
    if (!noWindow()) {
      console.error(errorMsg);
    }
  }
};

/** retry an operation a certain number of times
 * @param operation operation that needs to be retried
 * @param maxRetries Max number of retries allowed, by default RETRIES times
 * @param delay specifies the delay between retry attempts, by default RETRY_INTERVAL
 * @param param parameters to be passed to 'operation' function
 * @returns Promise<any>
 */
export var retryOperation = function retryOperation(_ref) {
  var operation = _ref.operation,
    _ref$maxRetries = _ref.maxRetries,
    maxRetries = _ref$maxRetries === void 0 ? RETRIES : _ref$maxRetries,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? RETRY_INTERVAL : _ref$delay,
    params = _ref.params;
  return new Promise(function (resolve, reject) {
    var attemptOperation = function attemptOperation(currentAttempt) {
      operation(params).then(resolve)["catch"](function (error) {
        if (currentAttempt < maxRetries) {
          setTimeout(function () {
            return attemptOperation(currentAttempt + 1);
          }, delay);
        } else {
          reject(error);
        }
      });
    };
    attemptOperation(0);
  });
};
export var isSessionActive = function isSessionActive() {
  var sessionkey = ls.getItem(SESSION_ID);
  var csid = getCookie(EnrichData.CSID);
  if (sessionkey && sessionkey === csid) {
    return true;
  }
  // Creating a new session
  if (csid && csid !== UNDEFINED && csid !== NULL) {
    ls.setItem(SESSION_ID, csid);
  }
  return false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/utils/index.js
// module id = 127
// module chunks = 11